function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Inner Plugin Iframe",
  clipPath: "url(#clip0_268_1108)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M8.00781 0.5C6.04032 0.501049 4.15203 1.27519 2.75 2.65553V0.5H1.75V4.5H5.75V3.5H3.32147C3.92763 2.86818 4.6552 2.36535 5.4605 2.02167C6.2658 1.67799 7.13224 1.50055 8.00781 1.5C11.5875 1.5 14.5 4.4125 14.5 7.99219C14.5 11.5719 11.5875 14.4844 8.00781 14.4844C4.42812 14.4844 1.51562 11.5719 1.51562 7.99219H0.515625C0.515623 9.474 0.955031 10.9225 1.77828 12.1546C2.60154 13.3867 3.77166 14.347 5.14068 14.9141C6.50969 15.4811 8.01612 15.6295 9.46947 15.3404C10.9228 15.0513 12.2578 14.3378 13.3056 13.29C14.3534 12.2422 15.067 10.9072 15.356 9.45384C15.6451 8.0005 15.4968 6.49407 14.9297 5.12505C14.3626 3.75603 13.4023 2.58591 12.1703 1.76266C10.9382 0.939406 9.48963 0.499998 8.00781 0.5Z",
  fill: "#385CAD"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M7.50012 3.49854L7.4834 9.00007H11.5001V8.00007H8.48646L8.50012 3.5016L7.50012 3.49854Z",
  fill: "#385CAD"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_268_1108"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

const SvgInnerPluginIframe1 = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInnerPluginIframe1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Inner Plugin Iframe (1).b152d3f7.svg";
export { ForwardRef as ReactComponent };